// components/HistorySection.tsx
import { Box, Typography } from '@mui/material';
import HistoryItem from './HistoryItem';
import { styled } from '@mui/material/styles';

export interface HistoryData {
  year: string;
  description: string;
}

interface Props {
  title: string;
  items: HistoryData[];
}

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Pretendard',
  fontWeight: 600,
  fontSize: '1rem',
  lineHeight: '100%',
  letterSpacing: '0%',
  color: '#FFFFFF',
  [theme.breakpoints.up('sm')]: {
      fontWeight: 700,
    fontSize: '1.5rem', // sm 이상에서 폰트 크기 증가 (원하는 크기로 조절 가능)
  },
}));

const DividerLine = styled(Box)({
  width: '100%',
  height: '0px',
  borderBottom: '2px solid #6672A6',
  marginTop: '19px',
});

export default function HistorySection({ title, items }: Props) {
  return (
    <Box sx={{ mb: '5vh' }}>
      <Box>
        <SectionTitle>{title}</SectionTitle>
        <DividerLine />
      </Box>
      <Box sx={{ position: 'relative', px: { xs: 0, sm: '2.2vw' }, py: { xs: '2vh', sm: '5vh' } }}>
        {items.map((item, idx) => (
          <HistoryItem key={idx} year={item.year} description={item.description} isLast={idx === items.length - 1} />
        ))}
      </Box>
    </Box>
  );
}
